<template>
  <div class="card-body">
    <div class="fs-6 fw-bold text-center text-primary mb-5 my-4">
      <!-- logo otomatis dari backend / fallback -->
      <img :src="preview" alt="Logo Klinik" height="100">
    </div>
    <div class="container">
      <h1>Kebijakan Privasi</h1>

      <p>Aplikasi DZIKRY hanya dapat diakses melalui Play Store, salah satu prioritas utama kami adalah privasi pengunjung kami. Halaman Kebijakan Privasi ini berisi beberapa jenis informasi yang dikumpulkan dan bagaimana cara kami menggunakannya.</p>

      <h2>File Log</h2>

      <p>
        Aplikasi DZIKRY mengikuti prosedur standar menggunakan
        <i>file log</i>. File-file ini mencatat pengunjung ketika mereka
        menggunakan Aplikasi DZIKRY. File-file ini tersimpan didalam
        <i>server hosting</i> yang mana semua perusahaan
        <i>hosting</i>
        melakukan hal ini. Tindakan tersebut merupakan bagian dari analisis layanan
        <i>hosting</i>. Informasi yang dikumpulkan oleh
        <i>file log</i> termasuk alamat protokol internet (IP), Penyedia Layanan Internet (ISP), tanggal dan waktu, halaman rujukan/keluar.
        Hal ini tidak terkait dengan informasi apa pun yang dapat diidentifikasi secara pribadi. Tujuan dari informasi tersebut adalah untuk
        menganalisis tren, melacak pergerakan pengguna di situs, dan mengumpulkan informasi demografis.
      </p>

      <h2>Informasi yang Kami Kumpulkan</h2>

      <p>Aplikasi DZIKRY dapat mengumpulkan beberapa jenis informasi berikut:</p>

      <h3>1. Informasi Pribadi</h3>
      <div class="ms-4">
        <p>Informasi yang Anda masukkan secara langsung seperti :</p>

        <ul>
          <li>Nama</li>
          <li>Nomor telepon</li>
          <li>Tanggal lahir</li>
          <li>Usia kehamilan</li>
          <li>Riwayat kesehatan dan keluhan</li>
          <li>Catatan pemeriksaan klinik</li>
          <li>Informasi lain yang dibutuhkan untuk monitoring ibu hamil</li>
        </ul>
      </div>
      <h3>2. Informasi Teknis</h3>
      <div class="ms-4">
        <p>Secara otomatis dikumpulkan untuk meningkatkan pengalaman pengguna :</p>

        <ul>
          <li>Model perangkat</li>
          <li>Sistem operasi</li>
          <li>Versi aplikasi</li>
          <li>Log penggunaan aplikasi</li>
        </ul>
      </div>

      <h2>Bagaimana Kami Menggunakan Informasi</h2>

      <p>Informasi yang dikumpulkan digunakan untuk :</p>

      <ul>
        <li>Menyediakan fitur monitoring kesehatan ibu hamil</li>
        <li>Menyimpan rekam data kehamilan pengguna</li>
        <li>Memudahkan klinik dalam melakukan pemantauan</li>
        <li>Meningkatkan kualitas layanan dan fitur aplikasi</li>
        <li>Menghubungi pengguna terkait informasi medis atau jadwal pemeriksaan</li>
      </ul>

      <p>Kami tidak menjual, menyewakan, atau membagikan informasi pribadi kepada pihak ketiga untuk tujuan komersial.</p>

      <h2>Berbagi Informasi</h2>

      <p>Informasi Anda hanya dapat dibagikan kepada:</p>

      <h3>1. Pihak Ketiga yang Mendukung Operasional</h3>

      <div class="ms-4">
        <p>Seperti layanan penyimpanan cloud atau penyedia analitik aplikasi. Semua pihak ketiga terikat dengan kebijakan kerahasiaan data sesuai standar.</p>
      </div>

      <h3>2. Kepatuhan Hukum</h3>

      <div class="ms-4">
        <p>Jika diwajibkan oleh undang-undang, misalnya permintaan resmi pemerintah atau penegak hukum.</p>
      </div>

      <h2>Keamanan Data</h2>

      <p>Kami menerapkan berbagai langkah untuk melindungi data Anda:</p>

      <ul>
        <li>Enkripsi data dalam proses pengiriman</li>
        <li>Pembatasan akses pada data sensitif</li>
        <li>Penyimpanan data pada server yang aman</li>
      </ul>

      <p>Namun, tidak ada sistem yang sepenuhnya aman. Kami berusaha maksimal melindungi data Anda, tetapi tidak dapat menjamin keamanan absolut.</p>

      <h2>Hak Pengguna</h2>

      <p>Anda memiliki hak untuk:</p>

      <ul>
        <li>Mengakses data Anda</li>
        <li>Memperbaiki atau memperbarui data</li>
        <li>Menghapus akun dan seluruh data yang tersimpan</li>
        <li>Menarik izin akses aplikasi (lokasi, kamera, dll.)</li>
      </ul>

      <p>Untuk permintaan penghapusan data, Anda dapat menghubungi kami melalui kontak resmi di bawah.</p>

      <h2>Penyimpanan dan Penghapusan Data</h2>

      <p>
        Data akan disimpan selama akun Anda aktif. Jika Anda menghapus akun atau meminta penghapusan data,
        maka seluruh data akan dihapus dalam jangka waktu maksimal 30 hari.
      </p>

      <h2>Data Anak-Anak</h2>

      <p>Aplikasi DZIKRY tidak ditujukan untuk anak di bawah usia 13 tahun. Kami tidak mengumpulkan data anak secara sengaja tanpa izin orang tua.</p>

      <h2>Perubahan Kebijakan Privasi</h2>

      <p>
        Kami dapat memperbarui Kebijakan Privasi ini sewaktu-waktu. Perubahan akan diumumkan melalui aplikasi atau halaman resmi.
        Penggunaan berkelanjutan terhadap Aplikasi dianggap sebagai persetujuan Anda terhadap perubahan tersebut.
      </p>

      <h2>Hubungi Kami</h2>

      <p>Jika Anda memiliki pertanyaan atau permintaan terkait Kebijakan Privasi ini, silahkan hubungi di nomor telepon: 0811817333 / 081-8173331</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import config from '../config'

export default {
	metaInfo: {
		titleTemplate: 'Privacy Policy'
	},
	data() {
		return {
			faviconUrl: require('@/assets/favicon.ico'), // default lokal
			logoUrl: require('@/assets/logo_dzikri.png'), // default lokal
			token: localStorage.getItem('token'),
			showPassword: false,
			form: {
				username: null,
				password: null
			},
			errors: null
		}
	},
	computed: {
		...mapGetters({
			conf: 'location/getConfig'
		}),
		preview: {
			// getter
			get() {
				let url = ''
				if (this.conf && this.conf.logo) {
					url = config('api.baseUrl') + 'storage/uploads/' + this.conf.logo
				} else {
					url = this.logoUrl
				}
				return url
			},
			set(value) {
				this.conf.logo = value
			}
		}
	},
	methods: {
		...mapActions('auth', ['login', 'logout']),

		onSubmit: function() {
			console.log('sd')
			this.login({
				useremail: this.form.username,
				userpass: this.form.password
			})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`Login berhasil`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
				})
				.catch((err) => {
					let toast = this.$toasted.show(`${err.response.data.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					console.log('vue===========', err.response.data)
				})
		},
		onLogout: function() {
			this.logout({})
				.then((res) => {
					console.log('res===========', res)
				})
				.catch((err) => {
					console.log('err===========', err)
				})
		},
		setFavicon(iconPath) {
			let link = document.querySelector("link[rel~='icon']")
			if (!link) {
				link = document.createElement('link')
				link.rel = 'icon'
				document.getElementsByTagName('head')[0].appendChild(link)
			}
			link.href = iconPath
		}
	},
	created() {
		this.setFavicon(this.faviconUrl)
		if (this.token) {
			this.$router.push('/')
		}
	}
}
</script>

<style>
body {
	font-family: 'Helvetica Neue', Arial, sans-serif;
	font-size: 18px;
	color: #333;
	line-height: 1.7;
	padding: 40px;
	background: #fff;
}

h1,
h2,
h3 {
	font-weight: 600;
	margin-top: 40px;
	margin-bottom: 18px;
	color: #222;
}

h1 {
	font-size: 32px;
}
h2 {
	font-size: 26px;
}
h3 {
	font-size: 22px;
}

p {
	margin-bottom: 22px;
}

ul {
	margin-top: 8px;
	margin-bottom: 22px;
	margin-left: 40px;
	list-style-type: disc;
}

li {
	margin-bottom: 10px;
}

.top-title {
	font-size: 18px;
	color: #666;
	margin-bottom: 40px;
}
</style>